import { moment } from '../../utils/date-shim'

export default function ( { next } ) {
    let now = moment()

    if(parseInt(process.env.VUE_APP_MAINTENANCE_START) <= now.utcOffset('+0800').hour() && now.utcOffset('+0800').hour() <= parseInt(process.env.VUE_APP_MAINTENANCE_END)) {
        return next('/serverMaintenance')
    } else {
        return next()
    }
}
